<template>
    <div class="accordion-wrapper">
        <div>
            <AccordionLink :is-visible="visible" @click="toggle">
                <slot name="title"></slot>
            </AccordionLink>
        </div>
        <div class="accordion-content" :class="{ 'is-visible': visible }">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    import AccordionLink from "./AccordionLink.vue";

    export default {
        name: "accordion",
        components: { AccordionLink },
        data() {
            return {
                visible: false,
            };
        },
        methods: {
            toggle() {
                this.visible = !this.visible;
                this.$emit("toggle", this.visible);
            },
        },
    };
</script>

<style></style>
